import type TableColumPropType from '@park-ui/components/table/src/table-column/defaults'
import type { ExtractPropTypes, PropType } from 'vue'

export interface ColumnTypes
  extends ExtractPropTypes<typeof TableColumPropType> {
  display: boolean,
  tooltipWidth: string | number,
  customTooltip: boolean
}

export default {
  column: {
    type: Object as PropType<ColumnTypes>,
    require: true,
  },
}
